import React from 'react';
import PropTypes from 'prop-types';

// Mixin / Modules
import isResizable from '../../../../../../mixins/resizable';

// Base
import Avatar from '../../../../../base/avatar';
import Col from '../../../../../base/col';
import Placeholder from '../../../../../base/placeholder';
import Row from '../../../../../base/row';

class _Loading extends React.Component {
  static propTypes = {
    isMobile: PropTypes.bool.isRequired,
  }

  render() {
    const { isMobile } = this.props;

    return (
      <div className='flex flex-row'>
        <div className='margin-right-20'>
          <Avatar size='lg' />
        </div>
        <div className='flex-grow-1'>
          <Row noMargin>
            <Col s={12} className='lg-font'>
              <Placeholder lines={isMobile ? 15 : 7} />
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default isResizable(_Loading);